<template>
  <div class="tile is-ancestor">
    <div class="tile is-parent is-10 is-offset-3">
      <article class="tile is-child box">
        <h1 class="title"><i class="fa fa-compress"></i> Shorten your links</h1>
        <form v-on:submit.prevent="shortenURL" class="block is-flex">
          <input class="input urlinput" v-model="url" type="text" placeholder="Your original URL here">
          <button type="submit" class="button is-primary">&nbsp;Submit URL</button>
        </form>
        <div class="block is-flex">
          <table class="table is-striped is-narrow ">
            <thead>
            <tr>
              <th>Original URL</th>
              <th>Short URL</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="url in shorturls">
              <td><a :href="url.original" target="_blank">{{ url.original }}</a></td>
              <td><a :href="url.short" target="_blank" data-label="Copied" class="short-link">
                {{ url.short }}
              </a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </article>
    </div>
  </div>
</template>


<script>
  export default {

    data () {
      return {
        shorturls: [],
        url: ''
      }
    },
    methods: {
      shortenURL () {
        this.$http.post(
          '/api/v1/short',
          this.url
        ).then((response) => {
          if (response.data.success) {
            this.shorturls.push(response.data.url)
          }
        })
      },
      copyUrl (cururl) {
        let copyText = cururl
        let mark = null
        let selection = null
        let range = null
        try {
          let range = document.createRange()
          let selection = document.getSelection()

          mark = document.createElement('span')
          mark.textContent = copyText
          // reset user styles for span element
          mark.style.all = 'unset'
          // prevents scrolling to the end of the page
          mark.style.position = 'fixed'
          mark.style.top = 0
          mark.style.clip = 'rect(0, 0, 0, 0)'
          // used to preserve spaces and line breaks
          mark.style.whiteSpace = 'pre'
          // do not inherit user-select (it may be `none`)
          mark.style.webkitUserSelect = 'text'
          mark.style.MozUserSelect = 'text'
          mark.style.msUserSelect = 'text'
          mark.style.userSelect = 'text'

          document.body.appendChild(mark)

          range.selectNode(mark)
          selection.addRange(range)

          let successful = document.execCommand('copy')
          if (!successful) {
            throw new Error('copy command was unsuccessful')
          }
        } catch (err) {
          try {
            window.clipboardData.setData('text', copyText)
          } catch (err) {
            console.log('unable to copy')
          }
        } finally {
          if (selection) {
            if (typeof selection.removeRange === 'function') {
              selection.removeRange(range)
            } else {
              selection.removeAllRanges()
            }
          }
          let d = document.getElementsByClassName('short-link')
          d[0].className += ' copying'
          setTimeout(function () {
            d[0].className = 'short-link'
          }, 500)
          mark.blur()
          if (mark) {
            document.body.removeChild(mark)
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .table td, .table th {
    word-break: break-word;
    font-size: 95%
  }

  .urlinput {
    margin-right: 1rem;
  }

  .short-link {
    color: #00d1b2;
    cursor: pointer;
    text-decoration: none;
    transition: none 86ms ease-out;
    position: relative;
  }

  .short-link::after {
    content: attr(data-label);
    color: #00d1b2;
    display: inline-block;
    position: absolute;
    top: -2px;
    left: 50%;
    opacity: .001;
    text-align: center;
    -webkit-transform: translate3d(-50%, 0, 0);
    transform: translate3d(-50%, 0, 0);
    -webkit-backface-visibility: hidden;
    white-space: nowrap
  }

  .short-link.copying::after {
    -webkit-animation: floatup .5s ease-in-out;
    animation: floatup .5s ease-in-out
  }
</style>



// WEBPACK FOOTER //
// URLShortner.vue?009c5f58